module.exports = __webpack_public_path__ + "img/mapCenter.ece1a7f3.png";